<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="end">
      <ion-button (click)="cancel()">
        <ion-icon name="close" />
      </ion-button>
    </ion-buttons>
    <!--    <ion-title>{{ task.title }}</ion-title>-->
    <!--    <ion-buttons slot="end">-->
    <!--      <ion-button (click)="confirm()" [disabled]="this.task.title.trim() ==''" [strong]="true">Opslaan</ion-button>-->
  <!--    </ion-buttons>-->

  <!--    <ion-buttons *ngIf="task !== null" slot="end">-->
  <!--      <ion-button (click)="toggleActionSheet()">-->
  <!--        <ion-icon name="settings-outline" slot="icon-only"/>-->
<!--      </ion-button>-->
<!--    </ion-buttons>-->

</ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <!--<div class="modal-wrapper">-->
  <!--  <div>-->

  <!--    <ion-list lines="none">-->
  <!--      <ion-item *ngIf="task.submittedBy">-->
  <!--        <h1>{{ task.submittedBy?.firstName }} {{ task.submittedBy?.lastName }}</h1>-->
<!--      </ion-item>-->
<!--      <ion-item>-->
<!--        {{ task.title }}-->
<!--      </ion-item>-->

<!--      <ion-item color="medium">-->
<!--        {{ task.createdAt | date:'d MMMM y':'CEST':'nl-NL' }}-->
<!--      </ion-item>-->
<!--    </ion-list>-->
<!--  </div>-->
<!--<div>-->
<!--  <ion-button color="primary" expand="block" (click)="completeTask()">Taak voltooien</ion-button>-->
<!--  <ion-button color="medium" expand="block" (click)="cancel()">Sluiten</ion-button>-->
<!--</div>-->
<!--</div>-->
<!--</ion-content>-->




<ion-list lines="none">
  <ion-item class="ion-no-padding">
    <!--      <ion-label position="stacked">Titel</ion-label>-->
    <ion-text style="font-weight: bold"> {{ task.title }} </ion-text>
  </ion-item>
  @if (task.description) {
    <ion-item class="ion-no-padding">
      <!--      <ion-label position="stacked">Omschrijving / Extra informatie</ion-label>-->
      <ion-text>{{ task.description }}</ion-text>
    </ion-item>
  }
  <ion-item class="ion-no-padding">
    <ion-label position="stacked">Toegevoegd door</ion-label>
    <ion-text>{{ task.submittedBy.firstName + " " + task.submittedBy.lastName }}</ion-text>
  </ion-item>
  @if (task.completedBy !== null) {
    <ion-item class="ion-no-padding">
      <ion-label position="stacked">Afgevinkt door</ion-label>
      <ion-text>{{ task.completedBy.firstName + " " + task.completedBy.lastName }}</ion-text>
    </ion-item>
  }
  <ion-item  class="ion-no-padding">
    <ion-label position="stacked">Prioriteit</ion-label>
    <ion-text>{{ task.priority ?? Priority.Medium }}</ion-text>
  </ion-item>

  <ion-button (click)="loadImages()">Toon afbeeldingen</ion-button>

  <ul>
    @for (image of taskImageUrls; track image) {
      <li>{{ image }}:<br><img [src]="getImageUrl(image)" alt="" /></li>
    }
  </ul>

</ion-list>

</ion-content>
